/* eslint camelcase: "off" */
/**
 * Visual marker for UI elements that don't yet have a django-monolith
 * backend. Render alongside / inside the affected column header or
 * control. Once the corresponding endpoint exists, remove the
 * <PendingBackend /> usage.
 */
import React from 'react';
import { Tag } from '@jem-open/jem-ui';
import { AlertCircle } from 'lucide-react';


export const PendingBackend: React.FC<{ label?: string }> = ({ label }) => (
  <Tag variant="processing" title="No django-monolith endpoint yet — action unavailable.">
    {label || 'pending backend'}
  </Tag>
);


export const PendingBackendBanner: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="mb-sm flex items-start gap-xxs rounded-2xl border border-warning-border-default bg-warning-surface-subtle p-md">
    <AlertCircle size={16} className="mt-xxs text-warning-text-label flex-shrink-0" />
    <div className="text-xs text-warning-text-label">{children}</div>
  </div>
);
